import { EventCollector } from 'userlens-analytics-sdk'
import { LOAD_GTM } from '@/lib/env'

declare global {
    interface Window {
        dataLayer: Record<string, any>[]
    }
}

let userLensInitialized = false
let collector: EventCollector

const pushToDatalayer = (event_name: string, params: Record<string, any> = {}) => {
    const data_layer_o = {
        event: event_name,

        ...params,
    }

    window.dataLayer?.push(data_layer_o) // dataLayer will be undefined if GTM is not loaded

    // Only load UserLens if GTM is loaded. Just re-using the GTM flag here for simplicity.
    if (LOAD_GTM) {
        if (event_name === 'gtm_user_identified' && !userLensInitialized) {
            collector = new EventCollector({
                userId: params.user_attributes?.user_id?.toString(), // ✅ required
                WRITE_CODE: 'b1ea87ed-414d-4a90-afad-31ec3b2fa0ef', // ✅ required
                userTraits: params, // optional
                intervalTime: 5000, // optional
            })
            userLensInitialized = true
        } else if (userLensInitialized) {
            collector.pushEvent({ event: event_name, properties: params })
        }
    }
}

export { pushToDatalayer }
